export type ReviewSource = 'google' | 'booking';

export interface ReviewInput {
  id: string; // stable internal id (slug-like)
  authorName: string;
  headline?: string;
  reviewBody: string;
  datePublished: string; // ISO 8601
  inLanguage?: string; // e.g., 'en', 'es'
  source: ReviewSource;
  ratingValue: number;
  bestRating: number;
  worstRating?: number;
}

// Reviews to be used for the Hotel (accommodations page)
export const hotelReviews: ReviewInput[] = [
  {
    id: 'rayleen-booking',
    authorName: 'Rayleen',
    headline: 'Can not wait to come back!!',
    reviewBody:
      'Aarvee, our host was excellent and helped us with recommendations and sights to see. The accommodation is perfect, clean, neat and comfortable. Breakfast was awesome with a full supply of options to choose from. (Cons) Leaving!',
    datePublished: '2025-10-29',
    inLanguage: 'en',
    source: 'booking',
    ratingValue: 10,
    bestRating: 10,
    worstRating: 1,
  },
  {
    id: 'mark-booking',
    authorName: 'Mark',
    headline: 'Exceptional',
    reviewBody:
      "The atmosphere and scenery are breathtaking with impeccable hospitality. A timeless charm and comfort in the Jungfrau region; truly magical.",
    datePublished: '2025-07-11',
    inLanguage: 'en',
    source: 'booking',
    ratingValue: 10,
    bestRating: 10,
    worstRating: 1,
  },
  {
    id: 'bo-dean-google',
    authorName: 'Bo Dean',
    reviewBody:
      "Absolutely gracious staff and unforgettable stay. Charm from its 300+ years and all modern amenities. Amazing sunset views.",
    datePublished: '2025-07-15',
    inLanguage: 'en',
    source: 'google',
    ratingValue: 5,
    bestRating: 5,
    worstRating: 1,
  },
  {
    id: 'agustin-moyano-google',
    authorName: 'Agustin Moyano',
    reviewBody:
      'Hidden gem in the Interlaken area! Peaceful garden and epic terrace view. Booked a massage after hiking and felt like new.',
    datePublished: '2025-07-15',
    inLanguage: 'en',
    source: 'google',
    ratingValue: 5,
    bestRating: 5,
    worstRating: 1,
  },
];

export function mapReviewsToJsonLd(reviews: ReviewInput[]) {
  return reviews.map((r) => ({
    '@type': 'Review',
    '@id': `https://beatenberg-resortspa.ch/accommodations#review-${r.id}`,
    mainEntityOfPage:
      r.source === 'google'
        ? 'https://www.google.com/search?q=Beatenberg+Resort+%26+Spa+reviews'
        : 'https://www.booking.com/',
    isBasedOn:
      r.source === 'google'
        ? 'https://www.google.com/search?q=Beatenberg+Resort+%26+Spa+reviews'
        : 'https://www.booking.com/',
    publisher: {
      '@type': 'Organization',
      name: r.source === 'google' ? 'Google' : 'Booking.com',
    },
    author: { '@type': 'Person', name: r.authorName },
    headline: r.headline,
    reviewBody: r.reviewBody,
    datePublished: r.datePublished,
    inLanguage: r.inLanguage || 'en',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: String(r.ratingValue),
      bestRating: String(r.bestRating),
      worstRating: String(r.worstRating ?? 1),
    },
  }));
}






